import type { ReactNode } from 'react';
import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@rtkwlf/pro-solid-svg-icons/faQuestionCircle';
import type {
  CreateTicketInputTicketType,
  TicketTagType,
} from '@rtkwlf/rendall';
import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router-dom';

import type { LinkButtonProps } from '@packages/components/link-button';
import { LinkButton } from '@packages/components/link-button';

export type NewTicketInfo = {
  ticketType?: CreateTicketInputTicketType | undefined;
  subject?: string | undefined;
  relatedTicket?: number | undefined;
  description?: string | undefined;
  /** the url inside the contact form will pass to backend  */
  link?: string | undefined;
  /** show the link label inside the contact form */
  linkLabel?: string | undefined;
  /** the url need to return after ticket is successfully created */
  returnLink?: string | undefined;
  /** show the link label inside the successful message in return button */
  returnLabel?: string | undefined;
  securityEmergencyType?: string | undefined;
  tags?: Array<TicketTagType>;
};

export interface ContactConciergeLinkProps
  extends Omit<LinkButtonProps, 'to' | 'state' | 'children'> {
  state?: {
    // TODO: "InitialInfo" is not clear, need to rename it
    initialInfo?: NewTicketInfo;
    [key: string]: unknown;
  };
  children?: ReactNode;
}

export const ContactConciergeLink = ({
  state = {},
  children,
  ...rest
}: ContactConciergeLinkProps) => {
  const { t } = useTranslation();

  const initialInfo: NewTicketInfo = {
    link: window.location.href,
    linkLabel: document.title,
    ...state.initialInfo,
  };

  const label = children ?? t('components:contactConciergeLink.requestHelp');

  return (
    <LinkButton
      variant="link"
      iconLeft={<FontAwesomeIcon icon={faQuestionCircle} />}
      to={generatePath('/resource-center/contact-concierge')}
      state={{ ...state, initialInfo }}
      {...rest}
    >
      {label}
    </LinkButton>
  );
};
